import React from 'react';
import { cn } from '../../utils/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'primary' | 'white';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
  xl: 'h-12 w-12 border-4',
};

const variantClasses = {
  default: 'border-slate-200 border-t-slate-500',
  primary: 'border-[var(--app-primary-tint)] border-t-[#0F6B66]',
  white: 'border-white/30 border-t-white',
};

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  variant = 'primary',
  className,
}) => (
  <div
    className={cn(
      'inline-block rounded-full animate-spin',
      sizeClasses[size],
      variantClasses[variant],
      className
    )}
    role="status"
    aria-label="Loading"
  />
);

export interface LoadingProps {
  className?: string;
  text?: string;
  overlay?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  className,
  text = 'Loading…',
  overlay = false,
}) => {
  const content = (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Spinner size="lg" />
      {text ? <p className="text-sm text-[var(--app-text-muted)]">{text}</p> : null}
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        {content}
      </div>
    );
  }

  return content;
};
